module.exports = __webpack_public_path__ + "static/media/overview-figure.3b0354e4.svg";